// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { X, ShoppingCart } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useCart } from "../../utils/CartContext";
// import { LuUserX } from "react-icons/lu";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { useCurrency } from "../../context/CurrencyContext";
// import { formatingPrice } from "../../utils/formatingPrice";
// import { useTranslation } from "react-i18next";

// const Cart = () => {
//   const navigate = useNavigate();
//   const { currency, convertPrice } = useCurrency();
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language || "en";

//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showLoginModal, setShowLoginModal] = useState(false);
//   const [updatingItems, setUpdatingItems] = useState(new Set());

//   const { cartCount, fetchCartCount, resetCartCount } = useCart();
  
//   useEffect(() => {
//     AOS.init({ duration: 800, easing: "ease-out", once: true });
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);
  
//   const user = useMemo(() => {
//     const userData = localStorage.getItem("pm-user-data");
//     return userData ? JSON.parse(userData) : null;
//   }, []);

//   const userId = user?._id;

//   // Helper function to get localized text
//   const getLocalizedText = useCallback((item, field) => {
//     if (!item || !item[field]) return "";
    
//     // If value is a string (backward compatibility)
//     if (typeof item[field] === 'string') {
//       return item[field];
//     }
    
//     // If value is an object with language keys
//     if (typeof item[field] === 'object') {
//       return item[field][currentLanguage] || 
//              item[field].en || 
//              item[field].hi || 
//              item[field].es || 
//              item[field].zh || 
//              "";
//     }
    
//     return "";
//   }, [currentLanguage]);

//   const fetchCartData = useCallback(async () => {
//     if (!userId) {
//       setError(t("new_cart.user_not_logged_in") || "User not logged in");
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       setError(null);

//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/cart/get-users-cart/${userId}`,
//         {
//           timeout: 10000,
//         }
//       );

//       if (response.data && response.data.items) {
//         const transformedItems = response.data.items.map((item) => ({
//           id: item._id,
//           name: item.product?.name, // This will be an object with language keys
//           price: item.product.price,
//           quantity: item.quantity,
//           image: item.product.images[0],
//           productId: item.product._id,
//           gstPercentage: item.product.gstPercentage || 0,
//           extraTaxPercentage: item.product.extraTaxPercentage || 0,
//           shippingCharge: item.product.shippingCharge || 0,
//           // Store the full product object for localization
//           product: item.product,
//           // Add localized name
//           localizedName: getLocalizedText(item.product, "name") || ""
//         }));
//         setCartItems(transformedItems);
//       } else {
//         setCartItems([]);
//       }
//     } catch (err) {
//       console.error("Error fetching cart:", err);

//       if (err.response && err.response.status === 404) {
//         setCartItems([]);
//         setError(null);
//       } else if (err.code === "ECONNABORTED") {
//         setError(
//           t("new_cart.request_timeout") || "Request timed out. Please check your connection and try again."
//         );
//       } else {
//         setError(t("new_cart.failed_to_fetch") || "Failed to fetch cart data");
//       }
//     } finally {
//       setLoading(false);
//     }
//   }, [userId, getLocalizedText, t]);

//   useEffect(() => {
//     fetchCartData();
//   }, [fetchCartData]);

//   // Update localized names when language changes
//   useEffect(() => {
//     if (cartItems.length > 0) {
//       const updatedItems = cartItems.map(item => ({
//         ...item,
//         localizedName: getLocalizedText(item.product || item, "name") || item.localizedName || ""
//       }));
//       setCartItems(updatedItems);
//     }
//   }, [currentLanguage, getLocalizedText]);

//   const updateQuantity = useCallback(
//     async (itemId, newQuantity) => {
//       if (newQuantity < 1) return;

//       const item = cartItems.find((item) => item.id === itemId);
//       if (!item) return;

//       setCartItems((prevItems) =>
//         prevItems.map((item) =>
//           item.id === itemId ? { ...item, quantity: newQuantity } : item
//         )
//       );

//       setUpdatingItems((prev) => new Set(prev).add(itemId));

//       try {
//         const requestData = {
//           userId: userId,
//           items: [
//             {
//               productId: item.productId,
//               quantity: newQuantity,
//             },
//           ],
//         };

//         await axios.put(
//           `${process.env.REACT_APP_API_URL}/cart/update-items`,
//           requestData,
//           {
//             headers: {
//               "Content-Type": "application/json",
//             },
//             timeout: 8000,
//           }
//         );
//       } catch (err) {
//         console.error("Error updating quantity:", err);

//         setCartItems((prevItems) =>
//           prevItems.map((cartItem) =>
//             cartItem.id === itemId
//               ? { ...cartItem, quantity: item.quantity }
//               : cartItem
//           )
//         );

//         Swal.fire({
//           title: t("new_cart.error") || "Error!",
//           text: t("new_cart.update_failed") || "Failed to update quantity. Please try again.",
//           icon: "error",
//           timer: 3000,
//           showConfirmButton: false,
//         });
//       } finally {
//         setUpdatingItems((prev) => {
//           const newSet = new Set(prev);
//           newSet.delete(itemId);
//           return newSet;
//         });
//       }
//     },
//     [cartItems, userId, t]
//   );

//   const removeItem = useCallback(
//     async (productId) => {
//       const result = await Swal.fire({
//         title: t("new_cart.confirm_remove_title") || "Are you sure?",
//         text: t("new_cart.confirm_remove_text") || "You won't be able to revert this!",
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#3085d6",
//         cancelButtonColor: "#d33",
//         confirmButtonText: t("new_cart.confirm_remove_btn") || "Yes, delete it!",
//       });

//       if (result.isConfirmed) {
//         const originalItems = cartItems;
//         setCartItems((prevItems) =>
//           prevItems.filter((item) => item.productId !== productId)
//         );

//         Swal.fire({
//           title: t("new_cart.removing_item") || "Removing item...",
//           text: t("new_cart.removing_item_text") || "Please wait while we remove the item from your new_cart.",
//           icon: "info",
//           allowOutsideClick: false,
//           allowEscapeKey: false,
//           showConfirmButton: false,
//           didOpen: () => {
//             Swal.showLoading();
//           },
//         });

//         try {
//           await axios.delete(
//             `${process.env.REACT_APP_API_URL}/cart/remove-cart-item`,
//             {
//               params: {
//                 userId: userId,
//                 productId: productId,
//               },
//               timeout: 8000,
//             }
//           );

//           fetchCartCount();

//           Swal.fire({
//             title: t("new_cart.removed_title") || "Deleted!",
//             text: t("new_cart.removed_text") || "Item has been removed from new_cart.",
//             icon: "success",
//             timer: 2000,
//             showConfirmButton: false,
//           });
//         } catch (err) {
//           console.error("Error removing item:", err);
//           setCartItems(originalItems);

//           Swal.fire({
//             title: t("new_cart.remove_error_title") || "Error!",
//             text: t("new_cart.remove_error_text") || "Failed to remove item from new_cart.",
//             icon: "error",
//           });
//         }
//       }
//     },
//     [cartItems, userId, fetchCartCount, t]
//   );

//   const calculatedTotals = useMemo(() => {
//     const subtotal = cartItems.reduce(
//       (sum, item) => sum + item.price * item.quantity,
//       0
//     );

//     const shipping = cartItems.reduce(
//       (sum, item) => sum + item.shippingCharge * item.quantity,
//       0
//     );

//     const gst = cartItems.reduce(
//       (sum, item) =>
//         sum + (item.price * item.quantity * item.gstPercentage) / 100,
//       0
//     );

//     const extraTax = cartItems.reduce(
//       (sum, item) =>
//         sum + (item.price * item.quantity * item.extraTaxPercentage) / 100,
//       0
//     );

//     const total = subtotal + shipping + gst + extraTax;

//     return {
//       subtotal,
//       shipping,
//       gst,
//       extraTax,
//       total,
//     };
//   }, [cartItems]);

//   const CartItemMobile = React.memo(
//     ({ item, onUpdateQuantity, onRemoveItem, isUpdating }) => {
//       const productName = item.localizedName || getLocalizedText(item.product || item, "name") || t("new_cart.untitled_product") || "Untitled Product";
      
//       return (
//         <div className="bg-white p-4 rounded-lg shadow">
//           <div className="flex justify-between items-start">
//             <div className="flex items-center space-x-3">
//               <img
//                 src={item.image}
//                 alt={productName}
//                 className="w-12 h-12 object-cover rounded"
//                 loading="lazy"
//                 onError={(e) => {
//                   e.target.src = "https://via.placeholder.com/100x100?text=Product";
//                 }}
//               />
//               <h3 className="font-semibold text-gray-900 tracking-wide">
//                 {productName}
//               </h3>
//             </div>
//             <button
//               onClick={() => onRemoveItem(item.productId)}
//               className="text-gray-400 hover:text-red-500 transition-colors"
//               aria-label={t("new_cart.remove_item") || "Remove item"}
//             >
//               <X className="w-5 h-5" />
//             </button>
//           </div>
//           <div className="grid grid-cols-3 gap-4 mt-4">
//             <span className="font-bold">
//               {formatingPrice(convertPrice(item.price.toFixed(2)), currency)}
//             </span>
//             <QuantityControl
//               quantity={item.quantity}
//               onUpdateQuantity={(newQuantity) =>
//                 onUpdateQuantity(item.id, newQuantity)
//               }
//               isUpdating={isUpdating}
//             />
//             <span className="font-bold text-right">
//               {formatingPrice(convertPrice((item.price * item.quantity).toFixed(2)), currency)}
//             </span>
//           </div>
//         </div>
//       );
//     }
//   );

//   const CartItemDesktop = React.memo(
//     ({ item, onUpdateQuantity, onRemoveItem, isUpdating }) => {
//       const productName = item.localizedName || getLocalizedText(item.product || item, "name") || t("new_cart.untitled_product") || "Untitled Product";
      
//       return (
//         <tr>
//           <td className="px-6 py-4 whitespace-nowrap">
//             <div className="flex items-center space-x-4">
//               <img
//                 src={item.image}
//                 alt={productName}
//                 className="w-12 h-20 object-cover rounded"
//                 loading="lazy"
//                 onError={(e) => {
//                   e.target.src = "https://via.placeholder.com/100x100?text=Product";
//                 }}
//               />
//               <div className="text-sm font-medium text-gray-900">{productName}</div>
//             </div>
//           </td>
//           <td className="px-6 py-4 whitespace-nowrap">
//             <div className="text-sm text-gray-900">
//               {formatingPrice(convertPrice(item.price.toFixed(2)), currency)}
//             </div>
//           </td>
//           <td className="px-6 py-4 whitespace-nowrap">
//             <QuantityControl
//               quantity={item.quantity}
//               onUpdateQuantity={(newQuantity) =>
//                 onUpdateQuantity(item.id, newQuantity)
//               }
//               isUpdating={isUpdating}
//               desktop
//             />
//           </td>
//           <td className="px-6 py-4 whitespace-nowrap">
//             <div className="text-sm font-bold text-gray-900">
//               {formatingPrice(convertPrice((item.price * item.quantity).toFixed(2)), currency)}
//             </div>
//           </td>
//           <td className="px-6 py-4 whitespace-nowrap">
//             <button
//               onClick={() => onRemoveItem(item.productId)}
//               className="text-gray-400 hover:text-red-500 transition-colors"
//               aria-label={t("new_cart.remove_item") || "Remove item"}
//             >
//               <X className="w-5 h-5" />
//             </button>
//           </td>
//         </tr>
//       );
//     }
//   );

//   const QuantityControl = React.memo(
//     ({ quantity, onUpdateQuantity, isUpdating, desktop }) => {
//       const baseClasses = desktop
//         ? "flex items-center p-1 border rounded-full w-24"
//         : "flex items-center border rounded-full justify-center p-1";

//       return (
//         <div className={baseClasses}>
//           <button
//             onClick={() => onUpdateQuantity(quantity - 1)}
//             disabled={isUpdating || quantity <= 1}
//             className={`px-2 py-1 rounded-full ${desktop ? "flex-grow" : ""} ${
//               isUpdating || quantity <= 1
//                 ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                 : "bg-gray-100 hover:bg-gray-200 transition-colors"
//             }`}
//             aria-label={t("new_cart.decrease_quantity") || "Decrease quantity"}
//           >
//             -
//           </button>
//           <span className="px-2 py-1 text-center">
//             {isUpdating ? "..." : quantity}
//           </span>
//           <button
//             onClick={() => onUpdateQuantity(quantity + 1)}
//             disabled={isUpdating}
//             className={`px-2 py-1 rounded-full ${desktop ? "flex-grow" : ""} ${
//               isUpdating
//                 ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                 : "bg-gray-100 hover:bg-gray-200 transition-colors"
//             }`}
//             aria-label={t("new_cart.increase_quantity") || "Increase quantity"}
//           >
//             +
//           </button>
//         </div>
//       );
//     }
//   );

//   const CartSummary = React.memo(({ totals, onCheckout }) => {
//     const handleCheckout = () => {
//       if (localStorage.getItem("buy-now-product")) {
//         localStorage.removeItem("buy-now-product");
//       }

//       onCheckout();
//     };

//     return (
//       <div className="bg-white px-6 py-6 rounded-lg shadow">
//         <h2 className="text-xl font-bold mb-6">
//           {t("new_cart.cart_total") || "Cart Total"}
//         </h2>
//         <div className="space-y-4">
//           <div className="flex justify-between border-b pb-2">
//             <span className="font-semibold">
//               {t("new_cart.subtotal") || "Subtotal:"}
//             </span>
//             <span>
//               {formatingPrice(convertPrice(totals.subtotal.toFixed(2)), currency)}
//             </span>
//           </div>
//           <div className="flex justify-between border-b pb-2">
//             <span className="font-semibold">
//               {t("new_cart.shipping") || "Shipping:"}
//             </span>
//             <span>
//               {formatingPrice(convertPrice(totals.shipping.toFixed(2)), currency)}
//             </span>
//           </div>
//           <div className="flex justify-between border-b pb-2">
//             <span className="font-semibold">
//               {t("new_cart.gst") || "GST:"}
//             </span>
//             <span>
//               {formatingPrice(convertPrice(totals.gst.toFixed(2)), currency)}
//             </span>
//           </div>
//           <div className="flex justify-between border-b pb-2">
//             <span className="font-semibold">
//               {t("new_cart.extra_tax") || "Extra Tax:"}
//             </span>
//             <span>
//               {formatingPrice(convertPrice(totals.extraTax.toFixed(2)), currency)}
//             </span>
//           </div>
//           <div className="flex justify-between pt-2">
//             <span className="font-bold">
//               {t("new_cart.total") || "Total:"}
//             </span>
//             <span>
//               {formatingPrice(convertPrice(totals.total.toFixed(2)), currency)}
//             </span>
//           </div>
//         </div>
//         <button
//           onClick={handleCheckout}
//           className="w-full mt-6 bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-4 rounded transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
//           disabled={cartItems.length === 0}
//         >
//           {t("new_cart.proceed_checkout") || "Proceed to checkout"}
//         </button>
//       </div>
//     );
//   });

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-[#FBFBFB] px-4 md:px-10 py-10 animate-pulse">
//         {/* Header Skeleton */}
//         <div className="flex justify-between items-center mb-8">
//           <div className="h-7 w-40 bg-gray-300 rounded"></div>
//           <div className="h-6 w-16 bg-gray-300 rounded"></div>
//         </div>

//         {/* Main Layout */}
//         <div className="flex flex-col lg:flex-row gap-8">
//           {/* Items Section */}
//           <div className="lg:w-3/4 bg-white rounded-lg shadow p-4">
//             {[1, 2, 3].map((_, i) => (
//               <div
//                 key={i}
//                 className="flex items-center justify-between py-4 border-b last:border-none"
//               >
//                 {/* Image + Name */}
//                 <div className="flex items-center gap-4">
//                   <div className="w-14 h-20 bg-gray-300 rounded"></div>
//                   <div className="h-4 w-28 bg-gray-300 rounded"></div>
//                 </div>

//                 {/* Price */}
//                 <div className="h-4 w-16 bg-gray-300 rounded"></div>

//                 {/* Quantity Controls */}
//                 <div className="flex items-center gap-2">
//                   <div className="w-7 h-7 bg-gray-300 rounded-full"></div>
//                   <div className="w-6 h-6 bg-gray-300 rounded"></div>
//                   <div className="w-7 h-7 bg-gray-300 rounded-full"></div>
//                 </div>

//                 {/* Subtotal */}
//                 <div className="h-4 w-20 bg-gray-300 rounded"></div>

//                 {/* Remove Icon */}
//                 <div className="w-6 h-6 bg-gray-300 rounded-full"></div>
//               </div>
//             ))}
//           </div>

//           {/* Summary Section */}
//           <div className="lg:w-1/4 bg-white rounded-lg shadow p-6">
//             <div className="h-6 w-28 bg-gray-300 rounded mb-6"></div>

//             <div className="space-y-4">
//               {[1, 2, 3, 4].map((_, i) => (
//                 <div key={i} className="flex justify-between">
//                   <div className="h-4 w-24 bg-gray-300 rounded"></div>
//                   <div className="h-4 w-16 bg-gray-300 rounded"></div>
//                 </div>
//               ))}

//               <div className="h-12 bg-gray-300 rounded mt-6 w-full"></div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="px-4 md:px-10 py-10 flex flex-col bg-orange-50">
//         <div className="flex-grow flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-300">
//           <div className="backdrop-blur-md bg-white/80 border border-gray-200 shadow-2xl rounded-2xl max-w-md w-full text-center animate-fade-in">
//             {/* Icon and Error Text */}
//             <div className="flex flex-col items-center justify-center mb-6">
//               <div className="bg-red-100 text-red-600 p-3 rounded-full mb-3">
//                 <LuUserX size={20} />
//               </div>
//               <p className="text-md font-medium text-red-700">{error}</p>
//             </div>

//             {/* Retry Button */}
//             {error !== (t("new_cart.user_not_logged_in") || "User not logged in") && (
//               <button
//                 onClick={fetchCartData}
//                 className="w-full bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white font-semibold py-2.5 rounded-xl shadow-md transition-all duration-200"
//               >
//                 🔁 {t("new_cart.try_again") || "Try Again"}
//               </button>
//             )}

//             {/* Login Button */}
//             {error === (t("new_cart.user_not_logged_in") || "User not logged in") && (
//               <button
//                 onClick={() => setShowLoginModal(true)}
//                 className="w-full bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white font-semibold py-2.5 rounded-xl shadow-md transition-all duration-200"
//               >
//                 🔐 {t("new_cart.login_continue") || "Login to Continue"}
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className=" flex flex-col bg-[#FBFBFB]">
//       <main className="flex-grow w-full mx-auto px-4 md:px-10 py-10">
//         <div className="flex justify-between items-center mb-8">
//           <h1 className="text-3xl md:text-4xl font-philosopher text-gray-900">
//             {t("new_cart.shopping_cart") || "Shopping Cart"}
//           </h1>
//           {cartItems.length > 0 && (
//             <span className="text-gray-600 bg-gray-100 px-4 py-2 rounded-full">
//               {cartItems.length} {t("new_cart.items_count", { count: cartItems.length }) || 
//                 `${cartItems.length} item${cartItems.length !== 1 ? "s" : ""}`}
//             </span>
//           )}
//         </div>

//         {cartItems.length === 0 ? (
//           <div className="text-center py-10 bg-white rounded-lg shadow">
//             <ShoppingCart className="w-24 h-24 text-gray-300 mx-auto mb-6" />
//             <h2 className="text-2xl font-semibold font-philosopher text-gray-600 mb-2">
//               {t("new_cart.empty_cart_title") || "No Products Found in Cart"}
//             </h2>
//             <p className="text-gray-500 mb-6 font-philosopher">
//               {t("new_cart.empty_cart_message") || "Your cart is empty. Add some products to get started!"}
//             </p>
//             <button
//               onClick={() => navigate("/allproduct")}
//               className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg transition-colors font-semibold"
//             >
//               {t("new_cart.continue_shopping") || "Continue Shopping"}
//             </button>
//           </div>
//         ) : (
//           <div className="flex flex-col lg:flex-row gap-8">
//             <div className="lg:w-3/4">
//               {/* Mobile view */}
//               <div className="lg:hidden space-y-4">
//                 {cartItems.map((item) => (
//                   <CartItemMobile
//                     key={item.id}
//                     item={item}
//                     onUpdateQuantity={updateQuantity}
//                     onRemoveItem={removeItem}
//                     isUpdating={updatingItems.has(item.id)}
//                   />
//                 ))}
//               </div>

//               {/* Desktop view */}
//               <div className="hidden lg:block bg-white rounded-lg shadow overflow-hidden">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         {t("new_cart.product") || "PRODUCT"}
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         {t("new_cart.price") || "PRICE"}
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         {t("new_cart.quantity") || "QUANTITY"}
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         {t("new_cart.subtotal") || "SUBTOTAL"}
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {cartItems.map((item) => (
//                       <CartItemDesktop
//                         key={item.id}
//                         item={item}
//                         onUpdateQuantity={updateQuantity}
//                         onRemoveItem={removeItem}
//                         isUpdating={updatingItems.has(item.id)}
//                       />
//                     ))}
//                   </tbody>
//                 </table>
//                 <div className="w-full h-px bg-gray-200"></div>
//                 <div className="flex justify-center p-4">
//                   <button
//                     onClick={() => navigate("/allproduct")}
//                     className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded transition-colors"
//                   >
//                     {t("new_cart.return_shop") || "Return to shop"}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="lg:w-1/4">
//               <CartSummary
//                 totals={calculatedTotals}
//                 onCheckout={() => navigate("/checkout")}
//               />
//             </div>
//           </div>
//         )}
//       </main>
//     </div>
//   );
// };

// export default Cart;




import React, { useState, useEffect, useCallback, useMemo } from "react";
import { X, ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useCart } from "../../utils/CartContext";
import { LuUserX } from "react-icons/lu";
import AOS from "aos";
import "aos/dist/aos.css";
import { useCurrency } from "../../context/CurrencyContext";
import { formatingPrice } from "../../utils/formatingPrice";
import { useTranslation } from "react-i18next";
import GuestSession from "../../utils/guestSession";

const Cart = () => {
  const navigate = useNavigate();
  const { currency, convertPrice } = useCurrency();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [updatingItems, setUpdatingItems] = useState(new Set());

  // FIX: pull the shared cart mutation methods from CartContext instead of
  // re-implementing add/remove/update with raw axios in this file. This is
  // what was causing quantity updates and removals to silently fail —
  // this page's own axios calls never sent selectedHeight/selectedWeight,
  // so the backend couldn't find a matching item.
  const {
    cartCount,
    fetchCartCount,
    resetCartCount,
    updateCartItemQuantity,
    removeFromCart,
  } = useCart();

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-out", once: true });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const user = useMemo(() => {
    const userData = localStorage.getItem("pm-user-data");
    return userData ? JSON.parse(userData) : null;
  }, []);

  const userId = user?._id;
  const isLoggedIn = !!userId;

  // Helper function to get localized text
  const getLocalizedText = useCallback(
    (item, field) => {
      if (!item || !item[field]) return "";

      if (typeof item[field] === "string") {
        return item[field];
      }

      if (typeof item[field] === "object") {
        return (
          item[field][currentLanguage] ||
          item[field].en ||
          item[field].hi ||
          item[field].es ||
          item[field].zh ||
          ""
        );
      }

      return "";
    },
    [currentLanguage]
  );

  // Fetch cart data - works for both logged in and guest users
  const fetchCartData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      let response;

      if (isLoggedIn) {
        // Logged in user - fetch from API with userId
        response = await axios.get(
          `${process.env.REACT_APP_API_URL}/cart/get-cart/${userId}`,
          {
            timeout: 10000,
          }
        );
      } else {
        // Guest user - fetch with guestId
        const guestId = GuestSession.getGuestId();
        if (!guestId) {
          setCartItems([]);
          setLoading(false);
          return;
        }

        response = await axios.get(
          `${process.env.REACT_APP_API_URL}/cart/get-guest-cart/${guestId}`,
          {
            timeout: 10000,
          }
        );
      }

      if (response.data && response.data.data) {
        const items = response.data.data.items || [];
        const transformedItems = items.map((item) => ({
          id: item._id,
          name: item.product?.name,
          price: item.product?.price || 0,
          quantity: item.quantity || 1,
          image:
            item.product?.images?.[0] ||
            "https://via.placeholder.com/100x100?text=Product",
          productId: item.product?._id,
          // FIX: these two fields were missing before. The backend matches
          // cart items on product + selectedHeight + selectedWeight, so
          // without them here, update/remove requests never matched.
          selectedHeight: item.selectedHeight,
          selectedWeight: item.selectedWeight,
          gstPercentage: item.product?.gstPercentage || 0,
          extraTaxPercentage: item.product?.extraTaxPercentage || 0,
          shippingCharge: item.product?.shippingCharge || 0,
          product: item.product,
          localizedName: getLocalizedText(item.product, "name") || "",
        }));
        setCartItems(transformedItems);
      } else {
        setCartItems([]);
      }
    } catch (err) {
      console.error("Error fetching cart:", err);

      if (err.response && err.response.status === 404) {
        setCartItems([]);
        setError(null);
      } else if (err.code === "ECONNABORTED") {
        setError(
          t("new_cart.request_timeout") ||
            "Request timed out. Please check your connection and try again."
        );
      } else {
        setError(t("new_cart.failed_to_fetch") || "Failed to fetch cart data");
      }
    } finally {
      setLoading(false);
    }
  }, [isLoggedIn, userId, getLocalizedText, t]);

  useEffect(() => {
    fetchCartData();
  }, [fetchCartData]);

  // Update localized names when language changes
  useEffect(() => {
    if (cartItems.length > 0) {
      const updatedItems = cartItems.map((item) => ({
        ...item,
        localizedName:
          getLocalizedText(item.product || item, "name") ||
          item.localizedName ||
          "",
      }));
      setCartItems(updatedItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLanguage, getLocalizedText]);

  const updateQuantity = useCallback(
    async (itemId, newQuantity) => {
      if (newQuantity < 1) return;

      const item = cartItems.find((item) => item.id === itemId);
      if (!item) return;

      const previousQuantity = item.quantity;

      // Optimistic update
      setCartItems((prevItems) =>
        prevItems.map((item) =>
          item.id === itemId ? { ...item, quantity: newQuantity } : item
        )
      );

      setUpdatingItems((prev) => new Set(prev).add(itemId));

      // FIX: use CartContext's updateCartItemQuantity, which already sends
      // selectedHeight/selectedWeight along with productId + quantity.
      const result = await updateCartItemQuantity(
        item.productId,
        newQuantity,
        item.selectedHeight,
        item.selectedWeight
      );

      if (!result?.success) {
        // Revert on failure
        setCartItems((prevItems) =>
          prevItems.map((cartItem) =>
            cartItem.id === itemId
              ? { ...cartItem, quantity: previousQuantity }
              : cartItem
          )
        );

        Swal.fire({
          title: t("new_cart.error") || "Error!",
          text:
            t("new_cart.update_failed") ||
            "Failed to update quantity. Please try again.",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        // Keep the navbar/badge count in sync
        await fetchCartCount();
      }

      setUpdatingItems((prev) => {
        const newSet = new Set(prev);
        newSet.delete(itemId);
        return newSet;
      });
    },
    [cartItems, updateCartItemQuantity, fetchCartCount, t]
  );

  const removeItem = useCallback(
    async (item) => {
      const result = await Swal.fire({
        title: t("new_cart.confirm_remove_title") || "Are you sure?",
        text:
          t("new_cart.confirm_remove_text") ||
          "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("new_cart.confirm_remove_btn") || "Yes, delete it!",
      });

      if (!result.isConfirmed) return;

      const originalItems = cartItems;

      setCartItems((prevItems) =>
        prevItems.filter((i) => i.productId !== item.productId)
      );

      Swal.fire({
        title: t("new_cart.removing_item") || "Removing item...",
        text:
          t("new_cart.removing_item_text") ||
          "Please wait while we remove the item from your cart.",
        icon: "info",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // FIX: use CartContext's removeFromCart, which sends
      // selectedHeight/selectedWeight so the backend can actually find
      // the matching item to remove.
      const response = await removeFromCart(
        item.productId,
        item.selectedHeight,
        item.selectedWeight
      );

      if (response?.success) {
        await fetchCartCount();
        // Re-sync full cart (in case of any drift) after removal
        await fetchCartData();

        Swal.fire({
          title: t("new_cart.removed_title") || "Deleted!",
          text: t("new_cart.removed_text") || "Item has been removed from cart.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        setCartItems(originalItems);

        Swal.fire({
          title: t("new_cart.remove_error_title") || "Error!",
          text:
            response?.error?.response?.data?.message ||
            t("new_cart.remove_error_text") ||
            "Failed to remove item from cart.",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        });
      }
    },
    [cartItems, removeFromCart, fetchCartCount, fetchCartData, t]
  );

  const calculatedTotals = useMemo(() => {
    const subtotal = cartItems.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );

    const shipping = cartItems.reduce(
      (sum, item) => sum + item.shippingCharge * item.quantity,
      0
    );

    const gst = cartItems.reduce(
      (sum, item) =>
        sum + (item.price * item.quantity * item.gstPercentage) / 100,
      0
    );

    const extraTax = cartItems.reduce(
      (sum, item) =>
        sum + (item.price * item.quantity * item.extraTaxPercentage) / 100,
      0
    );

    const total = subtotal + shipping + gst + extraTax;

    return {
      subtotal,
      shipping,
      gst,
      extraTax,
      total,
    };
  }, [cartItems]);

  // Reusable components
  const CartItemMobile = React.memo(
    ({ item, onUpdateQuantity, onRemoveItem, isUpdating }) => {
      const productName =
        item.localizedName ||
        getLocalizedText(item.product || item, "name") ||
        t("new_cart.untitled_product") ||
        "Untitled Product";

      return (
        <div className="bg-white p-4 rounded-lg shadow">
          <div className="flex justify-between items-start">
            <div className="flex items-center space-x-3">
              <img
                src={item.image}
                alt={productName}
                className="w-12 h-12 object-cover rounded"
                loading="lazy"
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/100x100?text=Product";
                }}
              />
              <h3 className="font-semibold text-gray-900 tracking-wide">
                {productName}
              </h3>
            </div>
            <button
              onClick={() => onRemoveItem(item)}
              className="text-gray-400 hover:text-red-500 transition-colors"
              aria-label={t("new_cart.remove_item") || "Remove item"}
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-4">
            <span className="font-bold">
              {formatingPrice(convertPrice(item.price.toFixed(2)), currency)}
            </span>
            <QuantityControl
              quantity={item.quantity}
              onUpdateQuantity={(newQuantity) =>
                onUpdateQuantity(item.id, newQuantity)
              }
              isUpdating={isUpdating}
            />
            <span className="font-bold text-right">
              {formatingPrice(
                convertPrice((item.price * item.quantity).toFixed(2)),
                currency
              )}
            </span>
          </div>
        </div>
      );
    }
  );

  const CartItemDesktop = React.memo(
    ({ item, onUpdateQuantity, onRemoveItem, isUpdating }) => {
      const productName =
        item.localizedName ||
        getLocalizedText(item.product || item, "name") ||
        t("new_cart.untitled_product") ||
        "Untitled Product";

      return (
        <tr>
          <td className="px-6 py-4 whitespace-nowrap">
            <div className="flex items-center space-x-4">
              <img
                src={item.image}
                alt={productName}
                className="w-12 h-20 object-cover rounded"
                loading="lazy"
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/100x100?text=Product";
                }}
              />
              <div className="text-sm font-medium text-gray-900">
                {productName}
              </div>
            </div>
          </td>
          <td className="px-6 py-4 whitespace-nowrap">
            <div className="text-sm text-gray-900">
              {formatingPrice(convertPrice(item.price.toFixed(2)), currency)}
            </div>
          </td>
          <td className="px-6 py-4 whitespace-nowrap">
            <QuantityControl
              quantity={item.quantity}
              onUpdateQuantity={(newQuantity) =>
                onUpdateQuantity(item.id, newQuantity)
              }
              isUpdating={isUpdating}
              desktop
            />
          </td>
          <td className="px-6 py-4 whitespace-nowrap">
            <div className="text-sm font-bold text-gray-900">
              {formatingPrice(
                convertPrice((item.price * item.quantity).toFixed(2)),
                currency
              )}
            </div>
          </td>
          <td className="px-6 py-4 whitespace-nowrap">
            <button
              onClick={() => onRemoveItem(item)}
              className="text-gray-400 hover:text-red-500 transition-colors"
              aria-label={t("new_cart.remove_item") || "Remove item"}
            >
              <X className="w-5 h-5" />
            </button>
          </td>
        </tr>
      );
    }
  );

  const QuantityControl = React.memo(
    ({ quantity, onUpdateQuantity, isUpdating, desktop }) => {
      const baseClasses = desktop
        ? "flex items-center p-1 border rounded-full w-24"
        : "flex items-center border rounded-full justify-center p-1";

      return (
        <div className={baseClasses}>
          <button
            onClick={() => onUpdateQuantity(quantity - 1)}
            disabled={isUpdating || quantity <= 1}
            className={`px-2 py-1 rounded-full ${desktop ? "flex-grow" : ""} ${
              isUpdating || quantity <= 1
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-gray-100 hover:bg-gray-200 transition-colors"
            }`}
            aria-label={t("new_cart.decrease_quantity") || "Decrease quantity"}
          >
            -
          </button>
          <span className="px-2 py-1 text-center">
            {isUpdating ? "..." : quantity}
          </span>
          <button
            onClick={() => onUpdateQuantity(quantity + 1)}
            disabled={isUpdating}
            className={`px-2 py-1 rounded-full ${desktop ? "flex-grow" : ""} ${
              isUpdating
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-gray-100 hover:bg-gray-200 transition-colors"
            }`}
            aria-label={t("new_cart.increase_quantity") || "Increase quantity"}
          >
            +
          </button>
        </div>
      );
    }
  );

  const CartSummary = React.memo(({ totals, onCheckout }) => {
    const handleCheckout = () => {
      if (localStorage.getItem("buy-now-product")) {
        localStorage.removeItem("buy-now-product");
      }
      onCheckout();
    };

    return (
      <div className="bg-white px-6 py-6 rounded-lg shadow">
        <h2 className="text-xl font-bold mb-6">
          {t("new_cart.cart_total") || "Cart Total"}
        </h2>
        <div className="space-y-4">
          <div className="flex justify-between border-b pb-2">
            <span className="font-semibold">
              {t("new_cart.subtotal") || "Subtotal:"}
            </span>
            <span>
              {formatingPrice(convertPrice(totals.subtotal.toFixed(2)), currency)}
            </span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="font-semibold">
              {t("new_cart.shipping") || "Shipping:"}
            </span>
            <span>
              {formatingPrice(convertPrice(totals.shipping.toFixed(2)), currency)}
            </span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="font-semibold">{t("new_cart.gst") || "GST:"}</span>
            <span>
              {formatingPrice(convertPrice(totals.gst.toFixed(2)), currency)}
            </span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="font-semibold">
              {t("new_cart.extra_tax") || "Extra Tax:"}
            </span>
            <span>
              {formatingPrice(convertPrice(totals.extraTax.toFixed(2)), currency)}
            </span>
          </div>
          <div className="flex justify-between pt-2">
            <span className="font-bold">{t("new_cart.total") || "Total:"}</span>
            <span>
              {formatingPrice(convertPrice(totals.total.toFixed(2)), currency)}
            </span>
          </div>
        </div>
        <button
          onClick={handleCheckout}
          className="w-full mt-6 bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-4 rounded transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
          disabled={cartItems.length === 0}
        >
          {t("new_cart.proceed_checkout") || "Proceed to checkout"}
        </button>
        {!isLoggedIn && (
          <p className="text-xs text-gray-500 text-center mt-2">
            {t("new_cart.guest_checkout_note") ||
              "You are checking out as a guest. Sign in to save your cart for future purchases."}
          </p>
        )}
      </div>
    );
  });

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FBFBFB] px-4 md:px-10 py-10 animate-pulse">
        <div className="flex justify-between items-center mb-8">
          <div className="h-7 w-40 bg-gray-300 rounded"></div>
          <div className="h-6 w-16 bg-gray-300 rounded"></div>
        </div>
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-3/4 bg-white rounded-lg shadow p-4">
            {[1, 2, 3].map((_, i) => (
              <div
                key={i}
                className="flex items-center justify-between py-4 border-b last:border-none"
              >
                <div className="flex items-center gap-4">
                  <div className="w-14 h-20 bg-gray-300 rounded"></div>
                  <div className="h-4 w-28 bg-gray-300 rounded"></div>
                </div>
                <div className="h-4 w-16 bg-gray-300 rounded"></div>
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 bg-gray-300 rounded-full"></div>
                  <div className="w-6 h-6 bg-gray-300 rounded"></div>
                  <div className="w-7 h-7 bg-gray-300 rounded-full"></div>
                </div>
                <div className="h-4 w-20 bg-gray-300 rounded"></div>
                <div className="w-6 h-6 bg-gray-300 rounded-full"></div>
              </div>
            ))}
          </div>
          <div className="lg:w-1/4 bg-white rounded-lg shadow p-6">
            <div className="h-6 w-28 bg-gray-300 rounded mb-6"></div>
            <div className="space-y-4">
              {[1, 2, 3, 4].map((_, i) => (
                <div key={i} className="flex justify-between">
                  <div className="h-4 w-24 bg-gray-300 rounded"></div>
                  <div className="h-4 w-16 bg-gray-300 rounded"></div>
                </div>
              ))}
              <div className="h-12 bg-gray-300 rounded mt-6 w-full"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Only show error if there's an actual error and cart is empty
  if (error && cartItems.length === 0) {
    return (
      <div className="px-4 md:px-10 py-10 flex flex-col bg-orange-50">
        <div className="flex-grow flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-300">
          <div className="backdrop-blur-md bg-white/80 border border-gray-200 shadow-2xl rounded-2xl max-w-md w-full text-center animate-fade-in">
            <div className="flex flex-col items-center justify-center mb-6">
              <div className="bg-red-100 text-red-600 p-3 rounded-full mb-3">
                <LuUserX size={20} />
              </div>
              <p className="text-md font-medium text-red-700">{error}</p>
            </div>

            {error !==
              (t("new_cart.user_not_logged_in") || "User not logged in") && (
              <button
                onClick={fetchCartData}
                className="w-full bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white font-semibold py-2.5 rounded-xl shadow-md transition-all duration-200"
              >
                🔁 {t("new_cart.try_again") || "Try Again"}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col bg-[#FBFBFB]">
      <main className="flex-grow w-full mx-auto px-4 md:px-10 py-10">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl md:text-4xl font-philosopher text-gray-900">
            {t("new_cart.shopping_cart") || "Shopping Cart"}
          </h1>
          {cartItems.length > 0 && (
            <span className="text-gray-600 bg-gray-100 px-4 py-2 rounded-full">
              {cartItems.length}{" "}
              {t("new_cart.items_count", { count: cartItems.length }) ||
                `${cartItems.length} item${cartItems.length !== 1 ? "s" : ""}`}
            </span>
          )}
        </div>

        {cartItems.length === 0 ? (
          <div className="text-center py-10 bg-white rounded-lg shadow">
            <ShoppingCart className="w-24 h-24 text-gray-300 mx-auto mb-6" />
            <h2 className="text-2xl font-semibold font-philosopher text-gray-600 mb-2">
              {t("new_cart.empty_cart_title") || "No Products Found in Cart"}
            </h2>
            <p className="text-gray-500 mb-6 font-philosopher">
              {t("new_cart.empty_cart_message") ||
                "Your cart is empty. Add some products to get started!"}
            </p>
            <button
              onClick={() => navigate("/allproduct")}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg transition-colors font-semibold"
            >
              {t("new_cart.continue_shopping") || "Continue Shopping"}
            </button>
          </div>
        ) : (
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="lg:w-3/4">
              <div className="lg:hidden space-y-4">
                {cartItems.map((item) => (
                  <CartItemMobile
                    key={item.id}
                    item={item}
                    onUpdateQuantity={updateQuantity}
                    onRemoveItem={removeItem}
                    isUpdating={updatingItems.has(item.id)}
                  />
                ))}
              </div>

              <div className="hidden lg:block bg-white rounded-lg shadow overflow-hidden">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {t("new_cart.product") || "PRODUCT"}
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {t("new_cart.price") || "PRICE"}
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {t("new_cart.quantity") || "QUANTITY"}
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {t("new_cart.subtotal") || "SUBTOTAL"}
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {cartItems.map((item) => (
                      <CartItemDesktop
                        key={item.id}
                        item={item}
                        onUpdateQuantity={updateQuantity}
                        onRemoveItem={removeItem}
                        isUpdating={updatingItems.has(item.id)}
                      />
                    ))}
                  </tbody>
                </table>
                <div className="w-full h-px bg-gray-200"></div>
                <div className="flex justify-center p-4">
                  <button
                    onClick={() => navigate("/allproduct")}
                    className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded transition-colors"
                  >
                    {t("new_cart.return_shop") || "Return to shop"}
                  </button>
                </div>
              </div>
            </div>

            <div className="lg:w-1/4">
              <CartSummary
                totals={calculatedTotals}
                onCheckout={() => navigate("/checkout")}
              />
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default Cart;